// ============================================================
// FILE: src/components/TestimonialCard.jsx
// ============================================================
import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const TestimonialCard = ({ name, content, avatar, delay = 0 }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -6, scale: 1.01 }}
            transition={{ duration: 0.6, delay }}
            className="bg-white/80 border border-[var(--color-border)]/70 p-5 md:p-6 flex flex-col min-h-[220px] rounded-[28px] shadow-[0_16px_50px_rgba(20,39,70,0.08)] hover:shadow-[0_24px_80px_rgba(20,39,70,0.12)] transition-all"
        >
            <div className="flex items-center gap-1 text-[var(--color-accent)] mb-3">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
            </div>
            <p className="text-[var(--color-dark)] text-sm leading-relaxed flex-grow">"{content}"</p>
            <div className="mt-4 pt-3 border-t border-slate-200">
                <div className="font-semibold text-sm text-slate-800">{name}</div>
            </div>
        </motion.div>
    );
};

export default TestimonialCard;